import { ref, computed } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { channelSupplierList } from '@/api/common'

interface JztChannelItem {
  /** 渠道编码 */
  businessCode: string
  /** 渠道名称 */
  businessName: string
  /** 供应商 id */
  providerId: number
  /** 渠道中台编码 */
  supplierCode: string
}

/** 系统对接渠道列表 */
const JZT_CHANNEL_LIST = ref<JztChannelItem[]>([])

/**
 * 拉取并写入系统对接渠道列表
 */
const GET_JZT_CHANNEL_LIST_ASYNC = async (): Promise<void> => {
  try {
    const list = await channelSupplierList()
    JZT_CHANNEL_LIST.value = list ?? []
  } catch (error) {
    console.error(error)
  }
}

/** 当前用户是系统对接渠道用户 */
const CURRENT_USER_IS_JZT_USER = computed(() => {
  return JZT_CHANNEL_LIST.value.some(
    (item) => item.supplierCode === useUserStore().getUserInfo?.supplierCode
  )
})

/**
 * 判断当前渠道是否属于系统对接渠道清单
 * @param supplierCode 渠道中台编码
 * @returns 是否命中清单
 */
const IS_JZT_CHANNEL = (supplierCode: string | undefined | null): boolean => {
  if (CURRENT_USER_IS_JZT_USER.value) return true
  if (!JZT_CHANNEL_LIST.value.length) return false
  return JZT_CHANNEL_LIST.value.some((item) => item.supplierCode === supplierCode)
}

export { JztChannelItem, GET_JZT_CHANNEL_LIST_ASYNC, IS_JZT_CHANNEL }
